
import axios, { Canceler } from 'axios';
//import { ITagType } from '@/interfaces/Tags/ITagType';
import { IFile } from '@/interfaces/Files/IFile';
import { IFileTags } from '@/interfaces/Files/IFileTags';
import { ITag } from '../interfaces/Tags/ITag';
const clientAPI = axios.create();

clientAPI.defaults.baseURL = process.env.VUE_APP_MYBASE_URL + '/api/';
clientAPI.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
clientAPI.defaults.headers.common.Pragma = 'no-cache';
clientAPI.defaults.headers.common.Expires = '0';

export { clientAPI };
export default class API {

    public static async getfiles() {
        const response = (await clientAPI.get('/files/allfiles')).data;

       if (response.success) {
            return response.data as IFile[];
        } else {
            throw new Error(response.errors);
        }


    }
    public static async getfilebyid(id:number) {
        const response = (await clientAPI.get('/Files/getfilebyid/'+id)).data;
        if (response.success) {
            return response.data as IFileTags[];
        } else {
            throw new Error(response.errors);
        }
        
    }
    public static async getfileselected(selected: any) {
        const result = (
            await clientAPI.post('/Files/allfiles_tags', selected)
        ).data;

        if (result.success) {
            return result.data as IFile[];
        } else {
            throw new Error(result.errors);
        }

    }
    public static async postfile(files: any) {
       const result = (
            await clientAPI.post('/Files/addfiles', files)
        ).data;

        if (result.success) {
            return result.data as IFile[];
        } else {
            throw new Error(result.errors);
        }
    }
    public static async editfile(updatefiles: any) {
   // public static async editfile(file: any, removeTagTypeSelected: Array<ITag>, insertTagTypeSelected: Array<ITag>, fileId) {}
        console.log("editted")
        console.log(updatefiles)
        const result = (
            await clientAPI.post('/Files/editfile', updatefiles)
        ).data;

        if (result.success) {
            return result.data as IFile[];
        } else {
            throw new Error(result.errors);
        }
    }
    //download file
    public static async downloadFile(fileid: string, fileName: string) {
       const formData: FormData = new FormData();
        formData.append('fileid', fileid);
        formData.append('fileName', fileName);
       
        const fileResult = (await clientAPI.post('/Files/DownloadFile', formData, {
            responseType: 'blob',
        }));

        if (fileResult) {
            const blobUrl = window.URL.createObjectURL(new Blob([fileResult.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', fileName); //or any other extension
            link.click();
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(blobUrl);
            }, 100);
        } else {
            throw new Error("No file found");
        }

    }

    public static async downloadAllFiles(selected: any) {
       
        const fileResult = (await clientAPI.post('/Files/DownloadFiles', selected, {
            responseType: 'blob',
        }));

        console.log(fileResult);

        if (fileResult) {
            const blobUrl = window.URL.createObjectURL(new Blob([fileResult.data]));
            //alert(blobUrl);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', 'Globalweb.zip'); //or any other extension
            console.log(link);
            link.click();
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(blobUrl);
            }, 100);
        } else {
            throw new Error("No file found");
        }

    }
    public static async deletefile(fileid: number) {
        try {
            console.log(fileid)
            const deleteResult = (await clientAPI.delete('/Files/deletefile/' + fileid)).data;

            return deleteResult.success;
        } catch (e) {
            // throw new Error(e.message);
        }
    }

}